import { Component } from '@angular/core';
import { ProductEnGbInterface } from '@app/core/interfaces/product.en-gb.interface';
import { NewModalRef } from 'outshared-lib';

@Component({
    selector: 'ins-premium-impact-modal',
    templateUrl: './premium-impact.modal.html',
    styleUrls: ['./premium-impact.modal.scss'],
})
export class PremiumImpactModal {
    products: ProductEnGbInterface[] = [];

    constructor(private newModalRef: NewModalRef<PremiumImpactModal>) {}

    public close(): void {
        this.newModalRef.close(false);
    }

    public confirm(): void {
        this.newModalRef.close(true);
    }
}
